/**
 * AmsConnectTour-specific types and step definitions.
 *
 * The AmsConnectTour walks admins through connecting HawkSoft
 * to Voley — explaining benefits (contact sync, logging, native
 * messaging), entering the Agency ID, and enabling contact sync.
 */

import type { TourStep } from '../types';

/** Unique identifiers for each AmsConnectTour step */
export type AmsConnectTourStepId =
  | 'ams_welcome'
  | 'highlight_hs_connect'
  | 'highlight_hs_modal'
  | 'highlight_contact_sync'
  | 'ams_complete';

/** Ordered list of all AmsConnectTour steps */
export const AMS_CONNECT_TOUR_STEPS: TourStep[] = [
  {
    id: 'ams_welcome',
    type: 'modal',
    title: '',
    content: '',
  },
  {
    id: 'highlight_hs_connect',
    type: 'highlight',
    targetSelector: '[data-tour-id="hs-connect-btn"]',
    title: 'Connect HawkSoft',
    content:
      'Click Connect to link your HawkSoft agency to Voley. This opens a quick setup where you\u2019ll enter your Agency ID.',
    placement: 'left',
    advanceOnElement: '[data-tour-id="hs-connection-modal"]',
  },
  {
    id: 'highlight_hs_modal',
    type: 'highlight',
    targetSelector: '[data-tour-id="hs-connection-modal"]',
    title: 'Enter Your Agency ID',
    content:
      'Find your Agency ID on your HawkSoft dashboard under Agency Settings. Enter it here and click Connect to finish linking your account.',
    placement: 'bottom',
    advanceOnElementRemoved: '[data-tour-id="hs-connection-modal"]',
  },
  {
    id: 'highlight_contact_sync',
    type: 'highlight',
    targetSelector: '[data-tour-id="hs-contact-sync"]',
    title: 'Automatic Contact Sync',
    content:
      'Once connected, you can enable daily automatic contact sync to keep Voley up to date with your AMS. Any client added or updated in HawkSoft will automatically appear in Voley \u2014 no manual entry needed.',
    placement: 'top',
  },
  {
    id: 'ams_complete',
    type: 'modal',
    title: '',
    content: '',
  },
];
